import React, { useEffect, useState } from "react";
import { Route, useNavigate } from "react-router-dom";

//models
import UserClass from "../General/LocalStorage/UserClass"
import DataManager from "../General/DataManager";

const ProtectedRoute = (props) => {

    const navigate = useNavigate();
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    const checkUserToken = () => {
        const userToken = UserClass.getInstance().getTokenUser();
        if (!userToken || typeof(userToken) === 'undefined' || userToken === null) {
            setIsLoggedIn(false);
            return navigate(`${process.env.PUBLIC_URL}/`);
        }



        const userInfo = UserClass.getInstance().getUser();
        if (props.hasOwnProperty("type") && props.type === "Device Manager" && userInfo.role !== "SYSADMIN" && userInfo.role !== "DEVICE_MANAGER" && userInfo.role !== "OPERATOR_CHECKIN" && userInfo.role !== "OPERATOR_SUPERVISOR") {
            setIsLoggedIn(false);
            return navigate(`${process.env.PUBLIC_URL}/`);
        }

        if (props.hasOwnProperty("type") && props.type === "Dashboard" && userInfo.role !== "SYSADMIN" && userInfo.role !== "OPERATOR") {
            setIsLoggedIn(false);
            return navigate(`${process.env.PUBLIC_URL}/`);
        }

        setIsLoggedIn(true);
    }



    useEffect(() => {
        checkUserToken();
    }, [isLoggedIn]);

    return (
        <React.Fragment>
            {
                isLoggedIn ? props.children : null
            }
        </React.Fragment>
    );
}

export default ProtectedRoute;
